// import { Outlet } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import { Container } from 'reactstrap';
// import Header from './header/Header';
// import Menubar from './sidebars/vertical/Menubar';
// import HorizontalHeader from './header/HorizontalHeader';
// import AppLogout from '../components/common/AppLogout';

// const FullLayout = () => {
//   const toggleMiniSidebar = useSelector((state) => state.customizer.isMiniSidebar);
//   const topbarFixed = useSelector((state) => state.customizer.isTopbarFixed);
//   const LayoutHorizontal = useSelector((state) => state.customizer.isLayoutHorizontal);

//   return (
//     <main className='retailer-layout'>
//       <div className={`pageWrapper d-md-block ${toggleMiniSidebar ? 'isMiniSidebar' : ''}`}>
//         <div className={`contentArea ${topbarFixed ? 'fixedTopbar' : ''}`}> 
//           <AppLogout>
//             {LayoutHorizontal ? <HorizontalHeader /> : <Header />}
//             {LayoutHorizontal ? <HorizontalHeader /> : <Menubar/>}
//             <Container fluid className="mt-2">
//                 <Outlet />
//             </Container>
//           </AppLogout>
//         </div>
//       </div>
//     </main>
//   );
// };

// export default FullLayout;

import { Outlet } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { Container } from 'reactstrap';
import Header from './header/Header';
import Sidebar from './sidebars/vertical/Sidebar';
import HorizontalHeader from './header/HorizontalHeader';
import HorizontalSidebar from './sidebars/horizontal/HorizontalSidebar';
import AppLogout from '../components/common/AppLogout';

const FullLayout = () => {
  const toggleMiniSidebar = useSelector((state) => state.customizer.isMiniSidebar);
  const showMobileSidebar = useSelector((state) => state.customizer.isMobileSidebar);
  const topbarFixed = useSelector((state) => state.customizer.isTopbarFixed);
  const LayoutHorizontal = useSelector((state) => state.customizer.isLayoutHorizontal);

  return (
    <main>
      <div className={`pageWrapper d-md-block d-lg-flex ${toggleMiniSidebar ? 'isMiniSidebar' : ''}`}>
        {LayoutHorizontal ? ('') : (
          <aside className={`sidebarArea ${showMobileSidebar ? 'showSidebar' : ''}`}>
            <Sidebar />
          </aside>
        )}
        <div className={`contentArea ${topbarFixed ? 'fixedTopbar' : ''}`}>
          <AppLogout>
            {LayoutHorizontal ? <HorizontalHeader /> : <Header />}
            {LayoutHorizontal ? <HorizontalSidebar /> : ''}
            <Container fluid className="mt-2 boxContainer">
                <Outlet />
            </Container>
          </AppLogout>
        </div>
      </div>
    </main>
  );
};

export default FullLayout;

